









import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { StateViewModel } from '@/features/bots/models/designer';
import IslandBadge from './IslandBadge.vue';

@Component({
	components: {
		IslandBadge
	}
})
export default class HumanHandover extends Vue {
	@Prop() public value: StateViewModel;

	public state: StateViewModel = {
		id: '',
		component: 'HumanHandover'
	};

	@Watch('value', { immediate: true })
	public onValueChanged(value: StateViewModel, previous: StateViewModel) {
		this.state = value;
	}
}
